import { fetcher } from '@commenda/utils';

import { TCreateBillingSkuDependencyParams } from './types';

export const createBillingSkuDependency = async (
  skuId: string,
  params: TCreateBillingSkuDependencyParams
) => {
  const response = await fetcher(
    `commenda-billing/catalog/skus/${skuId}/dependencies`,
    {
      method: 'POST',
      body: params,
    }
  );

  return response;
};
